import { useLocation } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { EmptyState } from "@/components/EmptyState";
import { ADMIN_MODULES } from "@/config/navigation";
import { useI18n } from "@/i18n/I18nProvider";

export default function ComingSoonModule() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const mod = ADMIN_MODULES.find((m) => m.path === pathname);
  if (!mod) return null;
  return (
    <div>
      <PageHeader title={t(`nav.${mod.key}`)} testId={`module-title-${mod.key}`} />
      <EmptyState
        testId={`module-coming-soon-${mod.key}`}
        icon={mod.icon}
        badge={t("common.comingSoon")}
        title={t(`modules.${mod.key}`)}
        description={t("modules.phaseNote")}
      />
    </div>
  );
}
